import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const CloseIconPlayerStats = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
        <Path
            stroke={props.color ?? ds.colorValue.background.danger.strong}
            strokeLinecap="round"
            strokeWidth={1.5}
            d="M12.035 4.465 8.5 8m0 0-3.536 3.536M8.5 8 4.964 4.465M8.5 8l3.535 3.536"
        />
    </Svg>
);
